<template>
  <PageHeader image="header-5" :title="$lang('title')" :breadcrumbs="$lang('breadcr')" withMobile />
  
  <!-- Main Content Section -->
  <section class="py-8 bg-blue4">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <h2 class="fw-bold text-blue2 mb-4">{{ $lang("section1.title") }}</h2>
          <p class="section-text mb-5">{{ $lang("section1.description") }}</p>
          
          <!-- Dublin Accommodation -->
          <div class="accommodation-section mb-6">
            <h3 class="fw-bold text-blue2 mb-4">Accommodation Dublin</h3>
            <div class="table-responsive">
              <table class="table table-accommodation">
                <thead>
                  <tr>
                    <th>Accommodation type</th>
                    <th>Type of room</th>
                    <th>Price per week</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Host Family</td>
                    <td>Single</td>
                    <td>€320 (Half board)</td>
                  </tr>
                  <tr>
                    <td>Host Family</td>
                    <td>Shared</td>
                    <td>€295 (Half board)</td>
                  </tr>
                  <tr>
                    <td>LEEVIN HOME+ | Student Residence</td>
                    <td>Single</td>
                    <td>€354</td>
                  </tr>
                  <tr>
                    <td>LEEVIN HOME+ | Student Residence</td>
                    <td>Double/Twin</td>
                    <td>€307</td>
                  </tr>
                  <tr>
                    <td>LEEVIN HOME+ | Student Residence</td>
                    <td>Triple</td>
                    <td>€290</td>
                  </tr>
                  <tr>
                    <td>LEEVIN HOME+ | Student Residence</td>
                    <td>Quadruple</td>
                    <td>€269</td>
                  </tr>
                  <tr>
                    <td>VIVA Dublin | Student Residence</td>
                    <td>Double</td>
                    <td>€612</td>
                  </tr>
                  <tr>
                    <td>VIVA Dublin | Student Residence</td>
                    <td>Single</td>
                    <td>€416</td>
                  </tr>
                  <tr>
                    <td>VIVA Dublin | Student Residence</td>
                    <td>Twin</td>
                    <td>€346</td>
                  </tr>
                  <tr>
                    <td>VIVA Dublin | Student Residence</td>
                    <td>Quadruple</td>
                    <td>€304</td>
                  </tr>
                  <tr>
                    <td>LEEVIN George - Mountjoy | Hostel</td>
                    <td>Shared 8-10 beds</td>
                    <td>€278</td>
                  </tr>
                  <tr>
                    <td>LEEVIN George - Mountjoy | Hostel</td>
                    <td>6 beds</td>
                    <td>€292</td>
                  </tr>
                  <tr>
                    <td>LEEVIN George - Mountjoy | Hostel</td>
                    <td>6 beds (Ensuite)</td>
                    <td>€299</td>
                  </tr>
                  <tr>
                    <td>LEEVIN George - Mountjoy | Hostel</td>
                    <td>3-4 beds</td>
                    <td>€348</td>
                  </tr>
                  <tr>
                    <td>LEEVIN George - Mountjoy | Hostel</td>
                    <td>3-4 beds (Ensuite)</td>
                    <td>€362</td>
                  </tr>
                  <tr>
                    <td>LEEVIN George - Mountjoy | Hostel</td>
                    <td>2 beds</td>
                    <td>€376</td>
                  </tr>
                  <tr>
                    <td>ISA | Student Residence</td>
                    <td>Single (Ensuite)</td>
                    <td>€975 (3 weeks)</td>
                  </tr>
                  <tr>
                    <td>ISA | Student Residence</td>
                    <td>Single</td>
                    <td>€930 (3 weeks)</td>
                  </tr>
                  <tr>
                    <td>ISA | Student Residence</td>
                    <td>Twin (Ensuite)</td>
                    <td>€780 (3 weeks)</td>
                  </tr>
                  <tr>
                    <td>ISA | Student Residence</td>
                    <td>Twin</td>
                    <td>€735 (3 weeks)</td>
                  </tr>
                  <tr>
                    <td>ISA | Student Residence</td>
                    <td>Double (Ensuite)</td>
                    <td>€1,290 (3 weeks)</td>
                  </tr>
                  <tr>
                    <td>ISA | Student Residence</td>
                    <td>Double</td>
                    <td>€1,230 (3 weeks)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="airport-pickup mt-5">
              <h4 class="fw-bold text-blue2 mb-3">DUBLIN AIRPORT PICK-UP</h4>
              <div class="pickup-info">
                <div class="row">
                  <div class="col-md-4">
                    <p class="pickup-label">Airport Transfer - <span class="pickup-value">€80</span></p>
                  </div>
                </div>
                <div>
                  <p class="pickup-details">Dublin Airport → Dublin City Centre | 1 way per person</p>
                </div>
              </div>
            </div>

            <div class="text-center mt-5 pb-5">
              <p class="mb-4">For full accommodation details and availability, get in touch with our team—we'll help you find the best option for your stay in Ireland.</p>
              <button class="btn btn-green-grad px-5" @click="goTo('contact_us')">
                Request Accommodation Info
              </button>
            </div>
          </div>

          <!-- Limerick Accommodation -->
          <div class="accommodation-section mb-6">
            <h3 class="fw-bold text-green1 mb-4">Accommodation Limerick</h3>
            <div class="table-responsive">
              <table class="table table-accommodation limerick">
                <thead>
                  <tr>
                    <th>Accommodation type</th>
                    <th>Type of room</th>
                    <th>Price per week</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Leevin Accommodation</td>
                    <td>4 Bed Mixed-Shared</td>
                    <td>€195</td>
                  </tr>
                  <tr>
                    <td>Leevin Accommodation</td>
                    <td>2 Bed Mixed-Twin</td>
                    <td>€205</td>
                  </tr>
                  <tr>
                    <td>Leevin Accommodation</td>
                    <td>Semi-private</td>
                    <td>€220</td>
                  </tr>
                  <tr>
                    <td>Leevin Accommodation</td>
                    <td>Single</td>
                    <td>€240</td>
                  </tr>
                  <tr>
                    <td>Point Accommodation</td>
                    <td>Shared</td>
                    <td>€220</td>
                  </tr>
                  <tr>
                    <td>Point Accommodation</td>
                    <td>Double (per person)</td>
                    <td>€240</td>
                  </tr>
                  <tr>
                    <td>Point Accommodation</td>
                    <td>Twin</td>
                    <td>€240</td>
                  </tr>
                  <tr>
                    <td>Point Accommodation</td>
                    <td>Single</td>
                    <td>€280</td>
                  </tr>
                  <tr>
                    <td>Host Family</td>
                    <td>Twin</td>
                    <td>€200 (Half board)</td>
                  </tr>
                  <tr>
                    <td>Host Family</td>
                    <td>Single</td>
                    <td>€230 (Half board)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="airport-pickup mt-5">
              <h4 class="fw-bold text-green1 mb-3">LIMERICK AIRPORT PICK-UP</h4>
              <div class="pickup-info">
                <div class="row">
                  <div class="col-md-4">
                    <p class="pickup-label">Airport Transfer - <span class="pickup-value">€80</span></p>
                  </div> 
                </div>
                <p class="pickup-details">FROM: Shannon Airport to Limerick City | 1 way per person</p>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <p class="pickup-label">Airport Transfer - <span class="pickup-value">€80</span></p>
                  </div>  
                </div>
                <p class="pickup-details">FROM: Dublin Airport to Limerick City by Bus + Limerick City to Accommodation by Transfer service | 1 way per person</p>
              </div>
            </div>
          </div>

          <div class="text-center mt-5">
            <p class="mb-4">For full accommodation details and availability, get in touch with our team—we'll help you find the best option for your stay in Ireland.</p>
            <button class="btn btn-green-grad px-5" @click="goTo('contact_us')">
              Request Accommodation Info
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- FAQ Section -->
  

  <!-- Testimonials Section -->
  <TestimonialSection
    :title="$lang('testimonials.title')"
    :subtitle="$lang('testimonials.subtitle')"
    :data="$lang('testimonials.data')"
  />
</template>

<script>
import PageHeader from "@/components/PageHeader";
import TestimonialSection from "@/components/TestimonialSection.vue";
import { trackEvent, StandardEvents } from "@/utils/facebookPixel";

export default {
  components: {
    PageHeader,
    TestimonialSection
  },
  mounted() {
    // Track ViewContent event for accommodation page
    trackEvent(StandardEvents.VIEW_CONTENT, {
      content_name: 'Accommodation Page',
      content_category: 'Student Services',
      content_type: 'product_group'
    });
  },
  methods: {
    goTo(route) {
      // Track accommodation interest when clicking contact us
      trackEvent(StandardEvents.LEAD, {
        content_name: 'Accommodation Interest',
        content_category: 'Student Services'
      });
      this.$router.push({ name: route });
    }
  }
};
</script>

<style>
/* Accommodation specific styles */
.accommodation-section {
  margin-bottom: 3rem;
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
}

.table-accommodation {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
  font-size: 1.15rem;
}

.table-accommodation thead {
  background-color: var(--blue2);
  color: white;
}

.table-accommodation.limerick thead {
  background-color: var(--green1);
}

.table-accommodation th {
  padding: 18px 15px;
  font-weight: 600;
  text-align: center;
  border: none;
  font-size: 1.2rem;
}

.table-accommodation td {
  padding: 15px;
  border: none;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  vertical-align: middle;
  font-size: 1.15rem;
}

.table-accommodation tbody tr:last-child td {
  border-bottom: none;
}

.table-accommodation tbody tr:nth-child(odd) {
  background-color: rgba(240,240,240,0.4);
}

.table-accommodation tbody tr:hover {
  background-color: rgba(200,230,255,0.3);
}

.airport-pickup {
  background-color: rgba(240,240,240,0.5);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  font-size: 1.15rem;
}

.pickup-info {
  padding: 10px;
}

.pickup-label {
  font-weight: 600;
  color: var(--green1);
  margin-bottom: 0;
  font-size: 1.15rem;
}

.pickup-value {
  font-weight: 700;
  font-size: 1.2rem;
  color: var(--blue2);
  margin-bottom: 0;
}

.pickup-details {
  color: var(--black2);
  margin-bottom: 0;
  font-size: 1.15rem;
  line-height: 1.5;
}

.section-text {
  font-size: 1.15rem;
  line-height: 1.6;
}

/* Responsive adjustments */
@media (max-width: 767px) {
  .pickup-details, .pickup-value, .pickup-label {
    text-align: center;
    margin-bottom: 10px;
  }
  
  .table-accommodation th,
  .table-accommodation td {
    padding: 10px 8px;
    font-size: 1.1rem;
  }
}
</style> 